import React from 'react';

/**
 * Wraps one overview section. If that section throws while rendering (for
 * example on data the normalizer did not anticipate), only it disappears; the
 * rest of the page, including the main button, keeps working.
 *
 * Not the app-wide ErrorBoundary: that one replaces the whole screen.
 */
class SectionBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error(`[Competition overview] "${this.props.name}" section failed to render`, error);
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}

export default SectionBoundary;
